import { render, staticRenderFns } from "./TwoColumnChart.vue?vue&type=template&id=5a2b8ffe&"
import script from "./TwoColumnChart.vue?vue&type=script&lang=js&"
export * from "./TwoColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports